import { get } from 'lodash';
import { Node_Type } from 'ricos-schema';
import { getCustomCoverImage, getResolvedCoverImage, } from '@wix/communities-universal/dist/src/services/get-post-cover';
import { resizeThumbnail } from './image-utils';
import { getVideoUrl } from './video-utils';
export const getRichContentPostCover = (post, imageHost, videoHost) => {
    const resolvedCoverImage = getResolvedCoverImage(post);
    if (resolvedCoverImage) {
        return resolvedCoverImage;
    }
    let { imageMetadata, videoMetadata, isCustom, isEnabled } = getCustomCoverImage(post);
    if (!imageMetadata) {
        imageMetadata = getPostImageCover(post.content);
    }
    if (!imageMetadata) {
        videoMetadata = getRichContentPostVideoEmbedCover(post.content, imageHost, videoHost);
    }
    return {
        shouldRender: Boolean(imageMetadata || videoMetadata) && isEnabled,
        imageMetadata,
        videoMetadata,
        src: imageMetadata || get(videoMetadata, 'thumbnail_url'),
        isEnabled,
        isCustom,
    };
};
export const getRichContentPostVideoEmbedCover = (content, imageHost, videoHost) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const nodes = (_a = content.nodes) !== null && _a !== void 0 ? _a : [];
    const node = nodes.find((n) => n.type === Node_Type.VIDEO);
    if (node === null || node === void 0 ? void 0 : node.videoData) {
        const thumbnail = node.videoData.thumbnail || {};
        const videoUrl = ((_c = (_b = node.videoData.video) === null || _b === void 0 ? void 0 : _b.src) === null || _c === void 0 ? void 0 : _c.id)
            ? getVideoUrl({ videoHost, pathname: node.videoData.video.src.id })
            : (_e = (_d = node.videoData.video) === null || _d === void 0 ? void 0 : _d.src) === null || _e === void 0 ? void 0 : _e.url;
        if ((_f = thumbnail.src) === null || _f === void 0 ? void 0 : _f.id) {
            const resized = resizeThumbnail({
                pathname: ((_g = thumbnail.src) === null || _g === void 0 ? void 0 : _g.id) || '',
                width: thumbnail.width,
                height: thumbnail.height,
                imageHost,
            });
            return {
                thumbnail_url: resized.url,
                thumbnail_height: resized.height,
                thumbnail_width: resized.width,
                video_url: videoUrl,
            };
        }
        return {
            thumbnail_url: (_h = thumbnail.src) === null || _h === void 0 ? void 0 : _h.url,
            thumbnail_height: thumbnail.height,
            thumbnail_width: thumbnail.width,
            video_url: videoUrl,
        };
    }
    return undefined;
};
const getPostImageCover = (content) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4;
    const nodes = (_a = content.nodes) !== null && _a !== void 0 ? _a : [];
    const image = nodes.find((node) => node.type === Node_Type.IMAGE);
    if (image === null || image === void 0 ? void 0 : image.imageData) {
        return {
            id: ((_c = (_b = image.imageData.image) === null || _b === void 0 ? void 0 : _b.src) === null || _c === void 0 ? void 0 : _c.id) || ((_e = (_d = image.imageData.image) === null || _d === void 0 ? void 0 : _d.src) === null || _e === void 0 ? void 0 : _e.url),
            file_name: ((_g = (_f = image.imageData.image) === null || _f === void 0 ? void 0 : _f.src) === null || _g === void 0 ? void 0 : _g.id) || ((_j = (_h = image.imageData.image) === null || _h === void 0 ? void 0 : _h.src) === null || _j === void 0 ? void 0 : _j.url),
            width: (_k = image.imageData.image) === null || _k === void 0 ? void 0 : _k.width,
            height: (_l = image.imageData.image) === null || _l === void 0 ? void 0 : _l.height,
        };
    }
    const gallery = nodes.find((node) => node.type === Node_Type.GALLERY);
    if (gallery === null || gallery === void 0 ? void 0 : gallery.galleryData) {
        const firstGalleryItem = (_o = (_m = gallery.galleryData) === null || _m === void 0 ? void 0 : _m.items) === null || _o === void 0 ? void 0 : _o[0];
        if (firstGalleryItem) {
            return {
                id: ((_r = (_q = (_p = firstGalleryItem.image) === null || _p === void 0 ? void 0 : _p.media) === null || _q === void 0 ? void 0 : _q.src) === null || _r === void 0 ? void 0 : _r.id) ||
                    ((_u = (_t = (_s = firstGalleryItem.image) === null || _s === void 0 ? void 0 : _s.media) === null || _t === void 0 ? void 0 : _t.src) === null || _u === void 0 ? void 0 : _u.url),
                file_name: ((_x = (_w = (_v = firstGalleryItem.image) === null || _v === void 0 ? void 0 : _v.media) === null || _w === void 0 ? void 0 : _w.src) === null || _x === void 0 ? void 0 : _x.id) ||
                    ((_0 = (_z = (_y = firstGalleryItem.image) === null || _y === void 0 ? void 0 : _y.media) === null || _z === void 0 ? void 0 : _z.src) === null || _0 === void 0 ? void 0 : _0.url),
                width: (_2 = (_1 = firstGalleryItem.image) === null || _1 === void 0 ? void 0 : _1.media) === null || _2 === void 0 ? void 0 : _2.width,
                height: (_4 = (_3 = firstGalleryItem.image) === null || _3 === void 0 ? void 0 : _3.media) === null || _4 === void 0 ? void 0 : _4.height,
            };
        }
    }
    return undefined;
};
//# sourceMappingURL=post-cover-utils.js.map